var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9202 2.35366L4.96325 10.5109C2.50877 11.9454 1 14.5748 1 17.4177V33.6791C1 36.522 2.50877 39.1514 4.96325 40.5859L18.9202 48.7431C21.4088 50.1976 24.4875 50.2008 26.9792 48.7515L41.0223 40.5832C43.4849 39.1508 45 36.5169 45 33.668V17.4288C45 14.5799 43.4849 11.946 41.0223 10.5135L26.9792 2.34525C24.4875 0.89593 21.4088 0.899141 18.9202 2.35366Z",
    fill: "white",
    stroke: "#ECE9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.271 5.31718L7.87458 12.0268C5.43255 13.4645 3.93335 16.0869 3.93335 18.9207V32.4126C3.93335 35.2464 5.43255 37.8688 7.87458 39.3065L19.271 46.0161C21.7708 47.4878 24.8713 47.4911 27.3741 46.0246L38.8443 39.3039C41.2945 37.8683 42.8 35.2413 42.8 32.4015V18.9318C42.8 16.092 41.2945 13.465 38.8443 12.0294L27.3741 5.30869C24.8713 3.84223 21.7708 3.84547 19.271 5.31718Z",
    fill: "#442B8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.391 8.4122L10.9208 13.4329C8.49031 14.8736 7 17.4894 7 20.3148V30.5519C7 33.3772 8.49031 35.9931 10.9208 37.4337L19.391 42.4545C21.9009 43.9423 25.0219 43.9455 27.535 42.463L36.0648 37.4311C38.5034 35.9925 40 33.3721 40 30.5407V20.3259C40 17.4946 38.5034 14.8741 36.0648 13.4355L27.535 8.40364C25.0219 6.92112 21.9009 6.9244 19.391 8.4122Z",
    fill: "#7B63BF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_485_117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 33,
    height: 37
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.391 8.4122L10.9208 13.4329C8.49031 14.8736 7 17.4894 7 20.3148V30.5519C7 33.3772 8.49031 35.9931 10.9208 37.4337L19.391 42.4545C21.9009 43.9423 25.0219 43.9455 27.535 42.463L36.0648 37.4311C38.5034 35.9925 40 33.3721 40 30.5407V20.3259C40 17.4946 38.5034 14.8741 36.0648 13.4355L27.535 8.40364C25.0219 6.92112 21.9009 6.9244 19.391 8.4122Z",
    fill: "#7B63BF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_485_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 16,
    height: 37,
    fill: "#7B63BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalPrimary);
export default __webpack_public_path__ + "static/media/medalPrimary.ed6d66f9489955ed99a42834e8896fb5.svg";
export { ForwardRef as ReactComponent };